import * as React from 'react'
import { cn } from '@/lib/utils'
import Card from 'app/frontend/base/components/Card'

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <Card className={cn('animate-pulse', className)} {...props} />
}

export { Skeleton }
